import { Controller } from "@hotwired/stimulus";
import { formSubmitWithWaitForJobCompletion, ajaxErrorHandler } from "../../../scripts/jobCompletion";
import { LoginModel } from "../../../scripts/_generated/LoginModel";
import * as moment from 'moment';
import 'moment-timezone';

export default class RegisterCompanyController extends Controller {
    static targets = [
        "form",
        "submitButton",
        "email",
        "password",
        "howDidYouHearAboutUsReferrer",
        "howDidYouHearAboutUsWebsite",
        "howDidYouHearAboutUsOther"
    ];
    
    static values = {
        getJobUrl: String,
        destinationsUrl: String,
        loginUrl: String
    };

    readonly formTarget!: HTMLElement;
    readonly submitButtonTarget!: HTMLElement;
    readonly emailTarget!: HTMLInputElement;
    readonly passwordTarget!: HTMLInputElement;
    readonly howDidYouHearAboutUsReferrerTarget!: HTMLInputElement;
    readonly howDidYouHearAboutUsWebsiteTarget!: HTMLInputElement;
    readonly howDidYouHearAboutUsOtherTarget!: HTMLInputElement;

    readonly getJobUrlValue!: string;
    readonly destinationsUrlValue!: string;
    readonly loginUrlValue!: string;

    connect() {
        formSubmitWithWaitForJobCompletion(
            $(this.formTarget),
            $(this.submitButtonTarget),
            this.getJobUrlValue,
            () => {
                this.logTheUserIn();
            },
            undefined,
            undefined,
            true,
            () => {
                // @ts-ignore
                updateReCaptcha();
            }
        );
    }

    logTheUserIn() {
        const loginModel: LoginModel = {
            email: this.emailTarget.value,
            password: this.passwordTarget.value,
            returnUrl: "",
            timeZone: moment.tz.guess(),
            message: "",
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]', this.formTarget).val() as string
        };

        $.ajax({
            url: this.loginUrlValue,
            type: "post",
            data: loginModel,
            success: () => {
                location.href = this.destinationsUrlValue;
            },
            error: (jqXhr, textStatus, errorThrown) => {
                ajaxErrorHandler(jqXhr, textStatus, errorThrown, this.loginUrlValue, loginModel);
            }
        });
    }

    referralSelected() {
        this.showReferrer();
        this.hideWebsite();
        this.hideOther();
    }

    websiteSelected() {
        this.hideReferrer();
        this.showWebsite();
        this.hideOther();
    }

    otherSelected() {
        this.hideReferrer();
        this.hideWebsite();
        this.showOther();
    }

    socialMediaSelected() {
        this.hideReferrer();
        this.hideWebsite();
        this.hideOther();
    }

    searchEngineSelected() {
        this.hideReferrer();
        this.hideWebsite();
        this.hideOther();
    }

    adSelected() {
        this.hideReferrer();
        this.hideWebsite();
        this.hideOther();
    }

    showReferrer() {
        this.howDidYouHearAboutUsReferrerTarget.style.display = "block";
    }

    hideReferrer() {
        this.howDidYouHearAboutUsReferrerTarget.style.display = "none";
    }

    showWebsite() {
        this.howDidYouHearAboutUsWebsiteTarget.style.display = "block";
    }

    hideWebsite() {
        this.howDidYouHearAboutUsWebsiteTarget.style.display = "none";
    }

    showOther() {
        this.howDidYouHearAboutUsOtherTarget.style.display = "block";
    }

    hideOther() {
        this.howDidYouHearAboutUsOtherTarget.style.display = "none";
    }

}